import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap-5';
import { faMemoPad, faPlus, faSearch, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputGroup, Form } from 'react-bootstrap-5';
import pluralize from 'pluralize';

import { Button } from 'components/ui/button';
import { deleteMailersTemplates } from 'bundles/connect/helpers/prospect_api';
import { displayToast } from 'bundles/connect/helpers/display_toast';
import type { MailersHeader, MailersTemplate } from 'bundles/connect/types';
import CreateTemplateModal from './create_template_modal';
import MailersHeaderEditModal from '../header/mailers_header_edit';

type MailersTemplatesTableHeaderProps = {
  callListId: number,
  header: MailersHeader;
  selectedTemplates: number[];
  setSelectedTemplates: React.Dispatch<React.SetStateAction<number[]>>;
  setTemplates: React.Dispatch<React.SetStateAction<MailersTemplate[]>>;
  total: number;
  onSearchTextChange: (text: string) => void;
  onUpdateTotal: (newTotal: number) => void;
}

export default function MailersTemplatesTableHeader({
  callListId,
  header,
  selectedTemplates,
  setSelectedTemplates,
  setTemplates,
  total,
  onSearchTextChange,
  onUpdateTotal
}: MailersTemplatesTableHeaderProps) {
  const [showLetterheadModal, setShowLetterheadModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleDelete = () => {
    if (window.confirm(
      `Are you sure you want to delete the selected mailer ${pluralize('template', selectedTemplates.length)}?`
    )) {
      deleteMailersTemplates(selectedTemplates).then(() => {
        setSelectedTemplates([]);
        setTemplates(prev => prev.filter(t => !selectedTemplates.includes(t.id)));
        onUpdateTotal(total - selectedTemplates.length);
        displayToast(`${pluralize('Template', selectedTemplates.length)} successfully deleted`, 'success');
      });
    }
  };

  return (
    <Row className="align-items-center gap-2">
      <Col className="col-auto">
        <h6 className="mb-0 fw-bold">Templates ({total})</h6>
      </Col>
      <Col className="ms-auto col-auto">
        <div className="d-flex align-items-center gap-2">
          {
            selectedTemplates.length > 0 && (
              <Button className="text-nowrap text-danger" icon={faTrash} variant="ghost" onClick={handleDelete}>
                Delete Selected ({selectedTemplates.length})
              </Button>
            )
          }
          <InputGroup className="flex-nowrap" style={{ width: 300 }}>
            <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
            <Form.Control
              id="mailers_template_search"
              placeholder="Search by Template Name"
              onChange={e => onSearchTextChange(e.target.value)}
            />
          </InputGroup>
          <Button
            className="text-nowrap"
            icon={faMemoPad}
            label="Edit Letterhead"
            variant="secondary"
            onClick={() => setShowLetterheadModal(true)}
          />
          <Button
            className="text-nowrap"
            icon={faPlus}
            label="New Template"
            onClick={() => setShowCreateModal(true)}
          />
          <CreateTemplateModal
            callListId={callListId}
            show={showCreateModal}
            onClose={() => setShowCreateModal(false)}
          />
          <MailersHeaderEditModal header={header} setShow={setShowLetterheadModal} show={showLetterheadModal} />
        </div>
      </Col>
    </Row>
  );
}
